<div class="c-layout">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-layout__background">
    <div class="c-layout__header">
      <div class="c-layout__header-logo"></div>
    </div>

    <div class="c-layout__page-background">
      <div class="c-layout__body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
